import request, { METHODS } from "src/utils/api-base";

const purchaseApis = {
  create: (payload: any) =>
    request({
      route: "/app/purchase-order/create",
      method: METHODS.POST,
      payload,
      auth: true,
    }),

  list: (params?: any) =>
    request({
      route: "/app/purchase-order/list",
      method: METHODS.GET,
      params,
      auth: true,
    }),

  getDetails: (id: string) =>
    request({
      route: `/app/purchase-order/${id}`,
      method: METHODS.GET,
      auth: true,
    }),

  update: (id: string, payload: any) =>
    request({
      route: `/app/purchase-order/${id}`,
      method: METHODS.PUT,
      payload,
      auth: true,
    }),
};

export default purchaseApis;
